module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-7.3943832c.svg";